import { any, array, func, number, string } from 'prop-types'
import { Link } from '@reach/router'
import React from 'react'

import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'

import styled from 'styled-components'
import { ROUTE_BASEPATH } from '../../constants'

const BreadcrumbWrapper = styled.div`
  margin: 0 auto;
  overflow: hidden;
  padding: ${( { padding } ) => padding};
  text-overflow: ellipsis;
  white-space: nowrap;
  width: ${( { largura } ) => largura};

  .hidden {
    display: none;
  }

  a {
    ${StyleGuide.tipografia.textoPequeno}
    font-weight: bold;

    &:not(:first-of-type) {
      padding-left: 5px;
    }

    &:last-of-type {
      color: ${StyleGuide.cores.azul};

      i {
        display: none;
      }
    }

    i {
      border: solid ${StyleGuide.cores.cinza300};
      border-width: 0 1px 1px 0;
      display: inline-block;
      padding: 4px;
      transform: rotate(-45deg);
    }
  }
`

const BreadcrumbGlobal = ( { nomeAlternativo, exactPath, largura, padding, palavrasExcluidas } ) => {
  // eslint-disable-next-line no-undef
  const path = window.location.pathname
  const pathArray = path.split( '/' )
  const basePath = ROUTE_BASEPATH.slice( 1 )

  // eslint-disable-next-line array-callback-return
  const steps = pathArray.map( ( item, index ) => {
    const itemPathRegex = new RegExp( `${item}([^]+).*`, 'u' )
    const pathRegex = path.replace( itemPathRegex, '' )
    const isExactPath = item === exactPath
    const ineditosRegex = /\bineditos\b/u
    const isIneditos = ineditosRegex.test( item ) ? item.replace( 'ineditos', 'Inéditos' ) : item
    let name = isExactPath ? nomeAlternativo : isIneditos
    name = name.charAt( 0 ).toUpperCase() + name.slice( 1 )

    if ( index !== 0 && item !== basePath ) {
      if ( ( palavrasExcluidas && !palavrasExcluidas.test( item ) ) || !palavrasExcluidas ) {
        return (
          <Link
            key={ name }
            to={ `${pathRegex}` }
          >
            { ` ${name} ` }

            <i />
          </Link>
        )
      }
    }
  } )

  return (
    <BreadcrumbWrapper
      largura={ largura }
      padding={ padding }
    >
      { steps }
    </BreadcrumbWrapper>
  )
}

BreadcrumbGlobal.propTypes = {
  'ativo': number,
  'exactPath': string,
  'largura': string,
  'margin': string,
  'nomeAlternativo': string,
  'onClick': func,
  'padding': string,
  'palavrasExcluidas': any,
  'passos': array
}

BreadcrumbGlobal.defaultProps = {
  'ativo': 1,
  'exactPath': '',
  'largura': '',
  'margin': '',
  'nomeAlternativo': '',
  'onClick': () => {},
  'padding': '11px 0',
  'palavrasExcluidas': null,
  'passos': []
}

export default BreadcrumbGlobal
